<template>
    <div>
    <div class="py-3"></div>
    
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar        
        :color="quizbundle_info.ref_pid == 0 ? 'light-blue darken-3' : 'grey darken-3'"
        dark
    >        
    <v-toolbar-title>이미지 퀴즈 번들정보</v-toolbar-title>
        <v-spacer/>
    </v-toolbar>
    <v-list>
        <!-- 유저 아이디  -->
         <v-list-item>
        <span style="width:200px"><v-card-title style="font-weight:bold">퀴즈 제목</v-card-title></span>        
        <span style="width:400px">
        <v-text-field
            label="카테고리 타이틀을 입력해주세요 (유저용) "
            v-model="quiz_bundle_title"
            value=""            
        ></v-text-field> 
        </span>
        </v-list-item>    
        <v-list-item>
        <span style="width:200px"><v-card-title style="font-weight:bold">퀴즈 제목(운영)</v-card-title></span>        
        <span style="width:400px">
        <v-text-field
            label="카테고리 타이틀을 입력해주세요 (운영자용) "
            v-model="quiz_bundle_title_comment"
            value=""            
        ></v-text-field> 
        </span>
        </v-list-item> 
        <v-list-item>
        <span style="width:200px"><v-card-title style="font-weight:bold">퀴즈 설명</v-card-title></span>        
        <span style="width:100%">
        <v-text-field
            label="퀴즈 부가설명을 입력해주세요 "
            v-model="quiz_bundle_desc_text"
            value=""            
        ></v-text-field> 
        </span>
        </v-list-item>      
        <v-list-item>
        <span style="width:160px"><v-card-title style="font-weight:bold">배너 이미지</v-card-title></span>        
        <span>
            <img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+quiz_bundle_bannerpath" alt="Image"  style="width: 120px; height: 60px; order: 2px solid black; border-radius: 10px;">             
        </span>        
        <span></span>        
        <v-col cols="12" md="6">
  <v-file-input
  hide-details
  outlined
  @change="handleFileChange"
>
  <template #label>
    배너이미지 변경하기
  </template>

</v-file-input>
      </v-col>
        </v-list-item>      
        <v-list-item>
            <span style="width:160px">
                <v-card-title style="font-weight:bold">퀴즈 난이도</v-card-title>
            </span>
            <span style="width:400px">
                <v-row class="flex-nowrap" no-gutters>
                <v-col
                    v-for="item in quiz_level_list"
                    :key="item.pid"
                    cols="auto"
                    class="pa-0"
                    style="min-width: 100px;"
                >
                    <v-checkbox
                    :label="item.category"
                    :value="item.pid"
                    v-model="selected_quiz_level"
                    hide-details
                    dense
                    />
                </v-col>
                </v-row>
            </span>
            </v-list-item>  
        <v-list-item style="display: flex; justify-content: center; align-items: center;">
            <!-- <v-btn width="120px"
                color="red"
                class='white--text'
                @click="OnSaveQuizBundle()">삭제하기</v-btn>
                <span style="width:30px"></span> -->
                <v-btn width="120px"
                color="blue"
                class='white--text'
                @click="OnSaveQuizBundle()">저장하기</v-btn>
                <span style="width:30px"></span>
                <v-btn
                v-if="quizbundle_info.ref_pid == 0"
                 width="120px"
                :color="quizbundle_info.dt_regist > quizbundle_info.dt_commit ? 'purple' : 'grey'"                     
                :class="quizbundle_info.dt_regist > quizbundle_info.dt_commit ? 'white--text' : 'black--text'"
                @click="OnCommitQuizBundle(quizbundle_info.pid)">커밋하기</v-btn>
        </v-list-item>

    </v-list>
    
    
    </v-card>

    <div style="height:20px"></div>


    <v-card v-if="quizbundle_info.ref_pid == 0"
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >    
    <v-toolbar-title>이미지 퀴즈 아이템 </v-toolbar-title>
        <v-spacer/>
        <v-btn
            color="cyan"
            small
            fab
            @click="OnClick_CreateItem"
        >
            <v-icon 
            color= "white"
            >mdi-plus</v-icon>
        </v-btn>
    </v-toolbar>

    <v-list>
        <v-data-table
            :footer-props="{'items-per-page-options': [-1]}"
            :headers="headers"
            :items="quiz_list_all"
            :loading="loadingData"
        >
            <template v-slot:item="{ item, index }">
            <tr>
                <!-- Index 표시 (1부터 시작) -->
                <td><v-col style="width: 60px;">{{ item.pid }} <span style="font-weight: 900;">({{quiz_list_all.length - index}})</span></v-col></td>

                <!-- 이미지 및 파일 입력 -->
                <td>
                <img
                    :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + item.img_path" 
                    alt="Image"
                    style="width: 120px; height: 60px; order: 2px solid black; border-radius: 10px; margin-top: 5px;"
                />
                <v-file-input
                    height="10px"
                    hide-details
                    outlined
                    v-model="quizImageFiles[item.pid]"
                    @change="(file) => handleFileChange_Quiz(file, item)"
                    dense
                    style=" margin-bottom: 5px;"
                >
                    <template #label>변경</template>
                </v-file-input>
                </td>

                <!-- 정답 텍스트 입력 -->
                <td>
                <v-text-field
                    v-model="item.correct"
                    outlined
                    dense
                    style="width: 120px;"
                    hide-details
                ></v-text-field>
                </td>

                <!-- 답변 텍스트 입력 -->
                <td>
                <v-text-field
                    v-model="item.answer"
                    outlined
                    dense
                    hide-details
                ></v-text-field>
                </td>

                <!-- 체크박스 -->
                <td>
                <v-checkbox
                    v-model="checkbox_state_container[item.pid]"
                    hide-details
                    label=""
                    class="my-auto"
                    @change="OnCheckBoxStateChange(item)"
                ></v-checkbox>
                </td>

                <!-- 등록 날짜 표시 -->
                <td>
                    <v-col>
                        <img
                            :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/snapquiz/commons/images/etc/UI_ImageQuiz_HideType_'+ (parseInt(item.hide_type) + 1)+'.png'"
                            alt="Image"
                            style="width: 40px; height: 40px; order: 2px solid black; border-radius: 10px; margin-top: 5px;"
                            @click="onDialogHideType(item)"
                        />
                    </v-col>
                </td>

                <!-- 삭제 버튼 -->
                <td>
                <v-btn
                    width="60px"
                    color="red"
                    class="white--text"
                    @click="OnDeleteQuiz_Item(item)"
                >
                    삭제
                </v-btn>
                </td>

                <!-- 수정 버튼 -->
                <td>
                <v-btn
                    width="60px"
                    color="blue"
                    class="white--text"
                    @click="OnSaveQuiz_Item(item)"
                >
                    수정
                </v-btn>
                </td>
            </tr>
            </template>
        </v-data-table>
        </v-list>

    </v-card>

    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5 mb-3">
            {{'퀴즈 등록하기'}}
        </v-card-title>

        <v-card-text>
            <v-row>
      <!-- 왼쪽: 이미지 업로드 입력 -->
      <v-col cols="12" md="6">
        <v-file-input
          label="배너이미지 (380*380)"
          accept="image/*"
          v-model="quizImageFile"
          prepend-icon="mdi-image"
          outlined
          @change="handleFileChange"
        />
      </v-col>
    </v-row>
    <v-row>
        <v-col cols="3"  class="text-center font-weight-bold text-h6">정답</v-col>
        <v-col><v-text-field 
                label="정답을 입력해주세요"
                v-model="dialog_correct" 
                outlined
                dense
            ></v-text-field></v-col>
    </v-row>
    <v-row>
        <v-col  cols="3"  class="text-center font-weight-bold text-h6">선택지</v-col>
        <v-col>
        <v-text-field 
                label="퀴즈 제목(유저에겐 보이지 않아요)"
                v-model="dialog_answer" 
                outlined
                dense
            ></v-text-field>
        </v-col>
    </v-row>
    <v-row>
        <v-col  cols="3"  class="text-center font-weight-bold text-h6">광고 여부</v-col>
        <v-col>
            <v-checkbox
      v-model="dialog_checkbox"
      label="(활성화시 퀴즈를 풀면 광고가 나옵니다)"
      class="my-auto"
    ></v-checkbox>
        </v-col>
    </v-row>
        <v-row>
            <v-col
                v-for="index in 15"
                :key="index"
                cols="3"
                class="d-flex justify-center"
                >
                <img
                    :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/snapquiz/commons/images/etc/UI_ImageQuiz_HideType_' + index + '.png'"
                    alt="Image"
                    :style="{
                    width: '40px',
                    height: '40px',
                    border: '1px solid black',
                    borderRadius: '5px',
                    marginTop: '5px',
                    backgroundColor: dialog_hide_type === index - 1 ? 'yellow' : 'transparent'
                    }"
                    @click="onCreateDialogHideType(index - 1)"
                />
                </v-col>
        </v-row>
      
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="CancelEdit"
          >
            취소
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="CreateQuiz"
          >
            SAVE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_select_hide_type"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5 mb-3">
          {{'숨김 타입 선택'}}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              v-for="index in 15"
              :key="index"
              cols="3"
              class="d-flex justify-center"
            >
              <img
                :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/snapquiz/commons/images/etc/UI_ImageQuiz_HideType_' + index + '.png'"
                alt="Image"
                :style="{
                  width: '40px',
                  height: '40px',
                  border: '1px solid black',
                  borderRadius: '5px',
                  marginTop: '5px',
                  backgroundColor: dialog_select_hide_type_item.hide_type === index - 1 ? 'yellow' : 'transparent'
                }"
                @click="onDialogHideType_Done(index - 1)"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="onCloseDialogHideType"
          >
            취소
          </v-btn>
          <!-- <v-btn
            color="green darken-1"
            text
            @click="CreateQuiz"
          >
            확인
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>

</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
const { s3_upload , FileUpload_Async ,  FileUpload_JSON} = require("../../util/fileutil");
import { format, parseISO } from 'date-fns'
export default {
    name: 'UserList',

    data: () => ({
        quiz_bundle_title :'',
        quiz_bundle_title_comment:'',
        quiz_bundle_desc_text:'',
        quiz_bundle_bannerpath :'',
        quizbundle_info:{},
        imageFile : null, 

        dialog_title_text :'',
        dialog_checkbox: false,
        dialog_hide_type:0,
        dialog_correct:'',
        dialog_answer:'',

        dialog : false,
        dialog_mode_is_edit : false,
        
        dialog_select_hide_type : false,
        dialog_select_hide_type_item : {},

        loadingData:false,        
        create_date:'',
        quiz_title_text : '',
        
        quizImageFile : null,
        headers: [            
            { text: '고유번호', value: 'pid' },
            { text: '이미지', value: 'img_path' },           
            { text: '정답', value: 'category' },            
            { text: '선택지', value: 'admin_user' },
            { text: '광고여부', value: 'need_ad' },
            { text: '더보기 타입', value: 'pid' },
            { text: '삭제', value: 'delete' },
            { text: '저장하기', value: 'save' },
        ],
        quiz_list_all:[
        ],
        quiz_dic_for_pid:{

        },
        checkbox_state_container:{},

        selected_editing_item:{},
        quizImageFiles:{},

        selected_quiz_level: [], // 체크된 pid 목록이 여기에 저장됨
        quiz_level_list: [
            { pid: 1, category: '레벨 1' },
            { pid: 2, category: '레벨 2' },
            { pid: 3, category: '레벨 3' },
            { pid: 4, category: '레벨 4' },
            { pid: 5, category: '레벨 5' },
        ]     
        
    }),

    created()
    {    
        this.LoadQuizBundleInfo(this.$route.query.pid);    
        this.LoadQuizList(this.$route.query.pid);
        // console.log("JSJS : "+ "수박바  " + this.OnAnswerCheck("수박바","기/치/거/딸/김/사/크/림/쉬/림/아/수"));
        // console.log("JSJS : "+ "홈런볼  "  + this.OnAnswerCheck("홈런볼","라/거/지/자/피/필/부/오/밥/차/리/또"));
        // console.log("JSJS : "+" 맛동산  "  + this.OnAnswerCheck("맛동산","라/거/지/자/피/필/부/오/밥/차/리/또"));
        // console.log("JSJS : "+" 투게더  "  + this.OnAnswerCheck("투게더","아/크/림/쉰/도/복/알/포/동/밥/미/비"));
    },


    methods:{
        ...mapActions([
            'EDIT_QUIZBUNDLE',
            'DELETE_QUIZ_BUNDLE',
            'COMMIT_QUIZBUNDLE',
            'GET_QUIZBUNDLE_INFO',
            'CREATE_QUIZ',
            'GET_QUIZLIST',
            'DELETE_QUIZ',
            'EDIT_QUIZ_INFO',
        ]),
        LoadQuizBundleInfo(pid){   
            this.GET_QUIZBUNDLE_INFO({pid}).then((body_data)=>{
                console.log(JSON.stringify(body_data));
                this.quizbundle_info = body_data.result;
                this.quiz_bundle_bannerpath = body_data.result.img_path;
                this.quiz_bundle_title = body_data.result.category;
                this.quiz_bundle_title_comment = body_data.result.category_comment;
                
                this.quiz_bundle_desc_text = body_data.result.desc_text;
                //this.selected_quiz_level = body_data.result.level;
                let levelStr = body_data.result.level;
                this.selected_quiz_level = []; // 초기화
                levelStr.split('').forEach((char, index) => {
                    if (char === 'Y') {
                        this.selected_quiz_level.push(index + 1); // 1~5 기준
                    }
                });
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            });           
        },
        LoadQuizList(bundle_pid)
        {
            this.quizImageFiles = {};
            this.checkbox_state_container = {};
            this.GET_QUIZLIST({bundle_pid}).then((body_data)=>{
                this.quiz_list_all = body_data.result;
                this.quiz_list_all.forEach((item) => {
                    this.checkbox_state_container[item.pid] = item.need_ad == 0 ? false: true; // 초기값을 false로 설정
                    this.quiz_dic_for_pid[item.pid] =  item;
                    this.quizImageFiles[item.pid] = null;
                });
            }).catch((err)=>{

            });
        },
        async CreateQuiz()
        {
            // this.dialog_title_text = this.dialog_title_text.replace(/\s/g, '');
            // this.dialog_correct = this.dialog_correct.replace(/\s/g, '');
            // this.dialog_answer = this.dialog_answer.replace(/\s/g, '');

            if(this.dialog_correct.replace(/\s/g, '') == "" ||  this.dialog_answer.replace(/\s/g, '') == "" )
            {
                alert("미입력한 정보가 있습니다.");
                return;
            }

            if(this.quizImageFile == null){
                alert("이미지 등록이 필요합니다.");
                return;
            }   
            
            this.loadingData = true;
            this.dialog = false;    
            var newFileName = "snapquiz/quiz_img/"+this.$route.query.pid+"/"+this.Utill_CreateNewImageName(this.imageFile.name);
            const awaitResult = await FileUpload_Async(this.imageFile, newFileName);
            if(awaitResult) {
                this.loadingData = false;
                    let bundle_pid = this.$route.query.pid;
                    let img_path = newFileName;         
                    let correct = this.dialog_correct;       
                    //let answer = this.dialog_answer;       
                    let answer = this.OnAnswerCheck( this.dialog_correct,this.dialog_answer);
                    let need_ad = this.dialog_checkbox?1:0;       
                    let hide_type = this.dialog_hide_type;

                    this.CREATE_QUIZ({ bundle_pid ,correct, answer , img_path , need_ad, hide_type}).then((body_data)=>{
                        this.LoadQuizList(this.$route.query.pid);
                    });
            }
        },
        handleFileChange(file)
        {
            this.imageFile = file;
            
        },
        handleFileChange_Quiz( file, item)
        {
            this.quizImageFiles[item.pid] = file;            
        },

        async OnSaveQuiz_Item(item)
        {
            if(this.quizImageFiles[item.pid] == null)
            {//변경된이미지가 없을때는 그냥 지정한다 
                let pid = item.pid;
                let bundle_pid = this.$route.query.pid;
                let correct = item.correct;
                //let answer  = item.answer;
                let answer = this.OnAnswerCheck( item.correct,item.answer);                
                let img_path = item.img_path;
                let hide_type = item.hide_type;
                //let need_ad = this.checkbox_state_container[item.pid] == 0?false:true;
                let need_ad = this.checkbox_state_container[item.pid] == false?0:1;
                this.EDIT_QUIZ_INFO({ bundle_pid, pid ,correct, answer , img_path , need_ad, hide_type}).then((body_data)=>{
                        this.LoadQuizList(this.$route.query.pid);
                        this.LoadQuizBundleInfo(this.$route.query.pid);    
                        alert('저장완료 1');
                    });
            }
            else{
                let changeImg = this.quizImageFiles[item.pid];
                var newFileName = "snapquiz/quiz_img/"+this.$route.query.pid+"/"+this.Utill_CreateNewImageName(changeImg.name);
                const await_result = await FileUpload_Async(changeImg, newFileName);
                if(await_result)
                {
                    let pid = item.pid;
                        let bundle_pid = this.$route.query.pid;
                        let correct = item.correct;
                        let answer  = item.answer;
                        let img_path = newFileName;
                        let need_ad = this.checkbox_state_container[item.pid] == 0?false:true;
                        let hide_type = item.hide_type;
                        this.EDIT_QUIZ_INFO({ bundle_pid, pid ,correct, answer , img_path , need_ad,  hide_type}).then((body_data)=>{
                                this.LoadQuizList(this.$route.query.pid);
                                this.LoadQuizBundleInfo(this.$route.query.pid);    
                                alert('저장완료 2');
                            });
                }
            }
        },
        OnAnswerCheck(correct,answer)
        {
            let correctList = correct.split(""); // "유재석" -> ["유", "재", "석"]
            let answerList = answer.split("/"); // "강/만/칙/장/참" -> ["강", "만", "칙", "장", "참"]
            // correctList의 모든 요소가 answerList에 포함되어 있는지 확인
            let isCorrect = correctList.every(char => answerList.includes(char));
            // 결과 출력
            if (isCorrect) {
                console.log("정답입니다!");
                return answer;
            } else {
                console.log("오답입니다.");
                  // answerList의 뒤를 자르고 correctList를 붙이기
                let trimmedAnswerList = answerList.slice(0, answerList.length - correctList.length);
                let combinedList = [...trimmedAnswerList, ...correctList];
                // 셔플된 리스트 생성
                let shuffledAnswerList = combinedList.sort(() => Math.random() - 0.5);
                // 셔플된 answer 리스트를 문자열로 반환
                return shuffledAnswerList.join("/");
            }
        },
        OnDeleteQuiz_Item(item)
        {
               // 기본 confirm 사용
            if (confirm("정말 삭제하시겠습니까?")) {
                    let pid = item.pid;
                    let bundle_pid = this.$route.query.pid;

                    // 삭제 로직 실행
                    this.DELETE_QUIZ({ bundle_pid, pid }).then((body_data) => {
                        this.LoadQuizList(this.$route.query.pid);
                        this.LoadQuizBundleInfo(this.$route.query.pid);    
                    }).catch((error) => {
                        console.error("삭제 실패:", error);
                    });
                } else {
                    // 취소를 누른 경우
                    console.log("삭제가 취소되었습니다.");
                }
            
            // let pid = item.pid;
            // let bundle_pid = this.$route.query.pid;
            // this.DELETE_QUIZ({ bundle_pid, pid}).then((body_data)=>{
            //     this.LoadQuizList(this.$route.query.pid);
            // });
        },

        OnClick_CreateItem()
        {
            this.dialog_title_text = "퀴즈 등록하기";
            // 디폴트 시간을 넣어준다.
            this.selected_editing_item = {}; 
            this.dialog_title_text = "";
            this.dialog_checkbox = false;
            this.dialog_hide_type = 0;
            this.dialog_correct = "";
            this.dialog_answer = "";
            this.quizImageFile = null;
            this.dialog = true;
        },
        OnCheckBoxStateChange(item)
        {
            console.log("아이템 변경 " + item.pid);
        },
        CancelEdit()
        {
            this.dialog = false;    
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        Utill_CreateNewImageName(originalFileName)
        { // 확장자 추출
            const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.')); // 예: ".png", ".jpg"
            // 랜덤 문자열 생성 (16자)
            const randomString = Math.random().toString(36).substring(2, 18); // 예: "5g8n4z6qx0ld3y7w"
            // 새 파일 이름 생성
            return randomString + fileExtension; // 예: "5g8n4z6qx0ld3y7w.png"
        },
        async OnCommitQuizBundle(bundle_pid)
        {
            var newFileName = this.quizbundle_info.commit_path;
            if(newFileName == "")
                newFileName = "snapquiz/quiz_data/"+this.Utill_CreateNewImageName('temp.json');            
            let quiz_data = this.quiz_list_all;
            if(await FileUpload_JSON(quiz_data, newFileName))
            {
                this.loadingData = false;
                    let pid = bundle_pid;        
                    let commit_path = newFileName;       
                    this.COMMIT_QUIZBUNDLE({pid, commit_path}).then((body_data)=>{
                        this.LoadQuizBundleInfo(this.$route.query.pid);                        
                    }).catch((err)=>{});
            }
        },
        async OnSaveQuizBundle()
        {
            //quiz_bundle_title
            //quiz_bundle_bannerpath
            if(this.imageFile == null)
            {
                let pid = this.$route.query.pid;
                    let category = this.quiz_bundle_title;
                    let category_comment = this.quiz_bundle_title_comment;
                    let img_path = this.quizbundle_info.img_path;
                    let desc_text = this.quiz_bundle_desc_text;
                    //let level = this.selected_quiz_level;
                    let level =  [1, 2, 3, 4, 5].map(pid => this.selected_quiz_level.includes(pid) ? 'Y' : 'X').join('');
                    this.EDIT_QUIZBUNDLE({ pid, category, category_comment,  level , img_path, desc_text}).then((body_data)=>{
                        alert('저장완료');                        
                        this.LoadQuizList(this.$route.query.pid);
                        this.LoadQuizBundleInfo(this.$route.query.pid);                                                
                    });
            }
            else{
                //var newFileName = "snapquiz/quiz_img/"+this.$route.query.pid+"/"+this.Utill_CreateNewImageName(this.imageFile.name);
                var newFileName = "snapquiz/quiz_img/banner/"+this.Utill_CreateNewImageName(this.imageFile.name);
                const await_result = await FileUpload_Async(this.imageFile, newFileName);
                if(await_result)
                {
                    this.loadingData = false;
                    let pid = this.$route.query.pid;
                    let category = this.quiz_bundle_title;
                    let img_path = newFileName;
                    let desc_text = this.quiz_bundle_desc_text;
                    let level = this.selected_quiz_level;
                    this.EDIT_QUIZBUNDLE({ pid, category, level , img_path, desc_text}).then((body_data)=>{
                        alert('저장완료');
                        this.LoadQuizList(this.$route.query.pid);
                        this.LoadQuizBundleInfo(this.$route.query.pid);
                    });
                }
            }
        },
        onImageClick(item) {
            // 여기에 이미지를 클릭했을 때 실행할 코드를 작성하세요.
            console.log("Image clicked:", item);
            // 예를 들어, 이미지를 확대해서 보여주는 로직을 추가할 수 있습니다.
        }, 
        onDialogHideType(item)
        {
            this.dialog_select_hide_type = true;
            this.dialog_select_hide_type_item  = item;
        },
        onDialogHideType_Done(hideType)
        {
            this.dialog_select_hide_type_item.hide_type = hideType;
            this.dialog_select_hide_type = false;
        },
        onCloseDialogHideType()
        {
            this.dialog_select_hide_type = false;
        },
        onCreateDialogHideType(index)
        {
            this.dialog_hide_type = index;
        }
        
    },
    computed: {
        isLive(){
            return config.isLive;
        },     
    },
    components:{
    },
    watch :{

    }
};
</script>
